export enum PurchaseSortField {
    CreatedDate,
    UpdatedDate,
    Title,
    Object,
    Number,
    NumberProcess,
    Year,
    Sequence,
    Modality,
    Situation,
    DisputeMode,
    ClientName
}
